/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { CarEquipmentDtoToJSON, CarEquipmentDtoGenericApiResponseFromJSON, CarEquipmentDtoListGenericApiResponseFromJSON, GarageSpotCreateDtoToJSON, GarageSpotDtoGenericApiResponseFromJSON, GarageSpotDtoSortedPagedListResponseGenericApiResponseFromJSON, GarageSpotUpdateDtoToJSON, Int32GenericApiResponseFromJSON, SuccessfullApiResponseFromJSON, } from '../models';
/**
 *
 */
export class GarageSpotApi extends runtime.BaseAPI {
    /**
     */
    apiGarageSpotAddEquipmentPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/GarageSpot/AddEquipment`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CarEquipmentDtoToJSON(requestParameters.carEquipmentDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarEquipmentDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotAddEquipmentPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotAddEquipmentPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotAddPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/GarageSpot/Add`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: GarageSpotCreateDtoToJSON(requestParameters.garageSpotCreateDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => Int32GenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotAddPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotAddPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotDeleteEquipmentDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.id !== undefined) {
                queryParameters['id'] = requestParameters.id;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/GarageSpot/DeleteEquipment`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotDeleteEquipmentDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotDeleteEquipmentDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotDeleteIdDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiGarageSpotDeleteIdDelete.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/GarageSpot/Delete/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotDeleteIdDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotDeleteIdDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotGetAllEquipmentForGarageSpotGarageSpotIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.garageSpotId === null || requestParameters.garageSpotId === undefined) {
                throw new runtime.RequiredError('garageSpotId', 'Required parameter requestParameters.garageSpotId was null or undefined when calling apiGarageSpotGetAllEquipmentForGarageSpotGarageSpotIdGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/GarageSpot/GetAllEquipmentForGarageSpot/{garageSpotId}`.replace(`{${"garageSpotId"}}`, encodeURIComponent(String(requestParameters.garageSpotId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarEquipmentDtoListGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotGetAllEquipmentForGarageSpotGarageSpotIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotGetAllEquipmentForGarageSpotGarageSpotIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotGetAllGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.pageNumber !== undefined) {
                queryParameters['PageNumber'] = requestParameters.pageNumber;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['PageSize'] = requestParameters.pageSize;
            }
            if (requestParameters.sortPropertyName !== undefined) {
                queryParameters['SortPropertyName'] = requestParameters.sortPropertyName;
            }
            if (requestParameters.sortDirection !== undefined) {
                queryParameters['SortDirection'] = requestParameters.sortDirection;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/GarageSpot/GetAll`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GarageSpotDtoSortedPagedListResponseGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotGetAllGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotGetAllGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotGetEquipmentByIdIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiGarageSpotGetEquipmentByIdIdGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/GarageSpot/GetEquipmentById/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarEquipmentDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotGetEquipmentByIdIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotGetEquipmentByIdIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotGetIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiGarageSpotGetIdGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/GarageSpot/Get/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GarageSpotDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotGetIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotGetIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotUpdateEquipmentPutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/GarageSpot/UpdateEquipment`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: CarEquipmentDtoToJSON(requestParameters.carEquipmentDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotUpdateEquipmentPut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotUpdateEquipmentPutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotUpdatePutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/GarageSpot/Update`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: GarageSpotUpdateDtoToJSON(requestParameters.garageSpotUpdateDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotUpdatePut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotUpdatePutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiGarageSpotUpdateWithDeleteEquipmentPutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/GarageSpot/UpdateWithDeleteEquipment`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: GarageSpotUpdateDtoToJSON(requestParameters.garageSpotUpdateDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGarageSpotUpdateWithDeleteEquipmentPut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGarageSpotUpdateWithDeleteEquipmentPutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
